import { IWindowSize } from "src/hooks";

export const generateSliderSettings = (size: IWindowSize) => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    centerPadding: "0px",
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
  };

  if (size?.width && size?.width > 1368) {
    settings.slidesToShow = 4;
  }
  if (size?.width && size?.width < 1368) {
    settings.slidesToShow = 3.5;
  }
  if (size?.width && size?.width < 1200) {
    settings.slidesToShow = 3.2;
  }
  if (size?.width && size?.width < 1024) {
    settings.slidesToShow = 2.4;
  }
  if (size?.width && size?.width < 700) {
    settings.slidesToShow = 1.8;
  }
  if (size?.width && size?.width < 500) {
    settings.slidesToShow = 1.4;
  }
  if (size?.width && size?.width < 425) {
    settings.slidesToShow = 1.1;
  }

  return settings;
};

export const generateSliderSettings2 = (size: IWindowSize) => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    centerPadding: "0px",
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    rows: 3,
  };

  if (size?.width && size?.width > 1368) {
    settings.slidesToShow = 4;
  }
  if (size?.width && size?.width < 1368) {
    settings.slidesToShow = 3.5;
  }
  if (size?.width && size?.width < 1200) {
    settings.slidesToShow = 3.2;
  }
  if (size?.width && size?.width < 1024) {
    settings.slidesToShow = 2.4;
  }
  if (size?.width && size?.width < 700) {
    settings.slidesToShow = 1.8;
  }
  if (size?.width && size?.width < 500) {
    settings.slidesToShow = 1.4;
  }
  if (size?.width && size?.width < 425) {
    settings.slidesToShow = 1.1;
  }

  return settings;
};
